import { useParams, useNavigate, useSearchParams } from "react-router";
import { Box, Button, Container, Typography } from "@mui/material";
import { FactoringImageGallery } from "components/FactoringImageGallery";

export default function FactoringImages() {
  const { factoringId } = useParams<{ factoringId: string }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleBackToList = () => {
    // Get the page parameter from the URL
    const page = searchParams.get("returnPage");
    if (page) {
      // Navigate back to the list with the page parameter
      navigate(`/factoring?page=${page}`);
    } else {
      // If no page parameter, just navigate back to the list
      navigate("/factoring");
    }
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        画像詳細
      </Typography>

      {factoringId && <FactoringImageGallery factoringId={factoringId} />}

      <Box sx={{ mt: 3 }}>
        <Button variant="outlined" onClick={handleBackToList}>
          一覧へ戻る
        </Button>
      </Box>
    </Container>
  );
}
